import '@sanctuairedelisi/scss/app-front-page.scss';
import Utils from '@sanctuairedelisi/js/services/utils';
import Slider from '@sanctuairedelisi/js/services/slider';
import Menu from '@sanctuairedelisi/js/services/menu';
import { add_swiper_class } from '@sanctuairedelisi/js/tools/swiper';
import Swiper from 'swiper';
import "jquery-match-height";

document.addEventListener( "DOMContentLoaded", function () {
    
    // Utils
    Utils.click();
    Utils.bootstrap();
    Utils.searchbox();
    Utils.smooth_scroll();
    Utils.lazy();
    Utils.obfuscation();
    Utils.toogle_menu_button();
    Utils.init_masonry();
    Utils.sticky_logo();
    Utils.sticky_topbar();
    Utils.manage_lang();
    
    const slider = $( '#wpiris-navigation-hero-slider' );
    
    let slider_wrapper = slider.find( '[data-id="wpiris-navigation-hero-slider-wrapper"]' ),
        slider_item    = slider.find( '[data-id="wpiris-navigation-hero-slider-item"]' );
    
    add_swiper_class( slider, $( slider_wrapper ), $( slider_item ) );
    
    const navigation_hero_swiper = new Swiper( $( slider ), {
        slidesPerView: 1,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        autoHeight: true,
    } );
    
    // Slider
    const hero_swiper = Slider.hero( {
                     watchSlidesVisibility: true,
                     watchSlidesProgress: true,
                     delay: 5000,
                 } );
    
    navigation_hero_swiper.controller.control = hero_swiper;
    hero_swiper.controller.control = navigation_hero_swiper;
    
    $( '.home .bannerContentQuote, #wpiris-navigation-hero-slider' ).matchHeight( {
                                                      target: $( '.bannerMedia' ),
                                                      property: 'min-height'
                                                  } );
    
    $.fn.matchHeight._afterUpdate = function ( event, groups ) {
        const height = $( '.home .bannerContentQuote, #wpiris-navigation-hero-slider' ).css( 'min-height' );
        $( '.home .bannerContentQuote, #wpiris-navigation-hero-slider' ).css( 'min-height', "calc( " + height + " - 160px )" );
    };
    
    Slider.messes( {
                       navigation: {
                           nextEl: '.messesArrowsItem--next',
                           prevEl: '.messesArrowsItem--prev',
                       }
                   } );
    Slider.agenda();
    Slider.le_sanctuaire();
    Slider.about();
    Slider.entity( {
                       breakpoints: {
                           370: {
                               slidesPerView: 2,
                               spaceBetween: 16
                           },
                           651: {
                               slidesPerView: 2,
                               spaceBetween: 30
                           },
                           1001: {
                               slidesPerView: 3,
                               spaceBetween: 20
                           },
                           1300: {
                               slidesPerView: 4,
                               spaceBetween: 20
                           },
                           1400: {
                               slidesPerView: 4,
                               spaceBetween: 40
                           }
                       }
                   } );
    
    new Menu();
} );
